import React, { useEffect, useState } from "react";
import ItemTypesList from "./item-types-list/item-types-list";
import ItemTypesAdd from "./item-types-add/item-types-add";
import ItemTypesEdit from "./item-types-edit/item-types-edit";
import ItemTypesDelete from "./item-types-delete/item-types-delete";
import { useNavigate } from "react-router-dom";
import { checkAuthState } from "../../authentication/auth-utils/auth-utils";

const ItemTypesContainer = () => {
    const navigate = useNavigate();
    const [isAuthorized, setIsAuthorized] = useState(null);

    useEffect(() => {
        checkAuthState((isLoggedIn) => {
          setIsAuthorized(isLoggedIn);
        });
    }, []);

    useEffect(() => {
        if (isAuthorized === false) {
          navigate('/');
        }
    }, [isAuthorized, navigate]);

    return (
        <>
            <div style={{ padding: 20 }}>
                <ItemTypesList/>
                <ItemTypesAdd/>
                <ItemTypesEdit/>
                <ItemTypesDelete/>
            </div>
        </>
    )
};

export default ItemTypesContainer;